import { memo, useRef, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';

const VirtualizedList = ({ data, renderItem, virtuosoRef, initialIndex = 0 }) => {
  const [isScrolling, setIsScrolling] = useState(false);

  const heights = useRef({});

  return (
    <Virtuoso
      ref={virtuosoRef}
      increaseViewportBy={{ top: 800, bottom: 800 }}
      className="h-full w-full"
      data={data}
      context={{ isScrolling }}
      isScrolling={setIsScrolling}
      itemContent={renderItem}
      initialTopMostItemIndex={initialIndex}
      heightEstimates={Object.values(heights.current)}
      itemSize={(el, size) => {
        const index = Number(el.dataset.index);
        const height = el[size];

        if (heights.current[index] !== height) {
          heights.current[index] = height;
        }

        return height;
      }}
    />
  );
};

export default memo(VirtualizedList);
